import { Box, Icons, Tag, Typography, withBrandColor } from '@castlery/fortress';
import { MappedSocialUgcItem } from '@castlery/modules-product-domain';
import { FortressImage } from '@castlery/shared-components';
import { generateVideoThumbnail } from '@castlery/utils';
import { useMemo } from 'react';

interface SocialUgcImageProps {
  ugc: MappedSocialUgcItem;
  showOverladed?: boolean;
}

export function SocialUgcImage(props: SocialUgcImageProps) {
  const { ugc, showOverladed = true, ...rest } = props;

  const mediaUrl = useMemo(() => {
    if (!ugc?.media) return '';

    if (ugc?.fileType === 'video') {
      const result = generateVideoThumbnail(ugc.media, {
        thumbnailAspectRatio: '1:1',
        thumbnailStartOffset: ugc?.startOffset || 0,
      });

      return result || ugc.media;
    }

    // 如果是图片类型，直接使用原始 URL
    return ugc.media;
  }, [ugc?.media, ugc?.fileType, ugc?.startOffset]);

  return (
    <Box
      key={ugc?._uid}
      sx={{
        position: 'relative',
        cursor: 'pointer',

        '&:hover': {
          '& img': {
            transform: 'scale(1.03)',
            transition: 'transform 0.3s ease',
          },
        },
      }}
      {...rest}
    >
      <FortressImage
        src={mediaUrl}
        alt={`Instagram post by ${ugc?.ig_handle || 'Castlery'} - ${ugc?._uid || 'post'}`}
        objectFit="cover"
        ratio={1}
        draggable
        sizes={['0.25-md', '0.33-sm', '0.67-xs']}
      />
      {['video']?.includes(ugc?.fileType) && (
        <Icons.PlayWhite
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            width: '64px',
            height: '64px',
          }}
        />
      )}
      {showOverladed && (
        <Tag
          sx={(theme) => ({
            position: 'absolute',
            bottom: theme.spacing(4),
            left: theme.spacing(4),
            ...withBrandColor('warmLinen', { variant: 'soft' }),
          })}
          variant="soft"
        >
          <Typography
            level="body2"
            sx={{
              fontFamily: 'var(--fortress-fontFamily-display)',
            }}
          >
            {ugc?.ig_handle}
          </Typography>
        </Tag>
      )}
    </Box>
  );
}
